import { memo } from 'react'
import styled from 'styled-components'
import { Column, SwimlaneCumulationData } from '../../Kanban'
import { SwimlaneStatusSummaryCard } from './SwimlaneStatusSummaryCard'
import { COLLAPSED_COLUMN_WIDTH } from '../Column'

type Props = {
  columns: Column[]
  statusCumulation: Record<string, SwimlaneCumulationData>
  columnCollapseState: Record<string, boolean>
}

const defaultCumulation: SwimlaneCumulationData = {
  count: 0,
  estimatedHour: 0,
  actualHour: 0,
}

export const SwimlaneStatusSummaryRow = memo(
  ({ columns, statusCumulation, columnCollapseState }: Props) => {
    return (
      <SummaryRow>
        {columns.map(column => {
          const isCollapsed = columnCollapseState[column.id] ?? false
          const cumulation = statusCumulation[column.id] ?? defaultCumulation
          return (
            <SummaryCell key={column.id} isCollapsed={isCollapsed}>
              {!isCollapsed && (
                <SwimlaneStatusSummaryCard
                  cumulation={cumulation}
                  backgroundColor={column.backgroundColor}
                />
              )}
            </SummaryCell>
          )
        })}
      </SummaryRow>
    )
  }
)

const SummaryRow = styled('div')({
  display: 'flex',
  flexWrap: 'nowrap',
  gap: '8px',
  padding: '4px 0',
})

const SummaryCell = styled('div')<{ isCollapsed: boolean }>(
  ({ isCollapsed }) => ({
    flex: isCollapsed ? 'none' : 1,
    minWidth: isCollapsed ? `${COLLAPSED_COLUMN_WIDTH}px` : '260px',
    display: 'flex',
    justifyContent: 'center',
    padding: '0 4px',
  })
)
